// API
import { tmxApiCall } from './index'

export default {
  async getCollateralPrices (applicationId, year, make, model, series, style, mileage, state) {
    return tmxApiCall('post', '/collateralPricing', {
      applicationId,
      year,
      make,
      model,
      series,
      style,
      mileage,
      state,
      brokenOdometer: 'false'
    })
  },

  async update (applicationId, userIsTitleHolder, state, titleAddress, customerEstimate, estimatePercent, year, make, model, series, style, vehicleMileage, lienHolderName, lienHolderPhone, lienHolderAccountNumber, estimatedPayoffAmount, vehicleCondition, registrationCounty) {
    return tmxApiCall('put', '/vehicle', {
      applicationId,
      userIsTitleHolder,
      state,
      titleAddress,
      customerEstimate,
      estimatePercent,
      year,
      make,
      model,
      series,
      style,
      vehicleMileage,
      lienHolderName,
      lienHolderPhone,
      lienHolderAccountNumber,
      estimatedPayoffAmount,
      vehicleCondition,
      registrationCounty
    })
  },

  updateLoginDataVehicle (applicationId, year, make, model, series, style) {
    return tmxApiCall('put', '/vehicle', {
      applicationId,
      year,
      make,
      model,
      series,
      style
    })
  },

  async updateCoOwner (applicationId, coOwnerFirstName, coOwnerMiddleName, coOwnerLastName, coOwnerSuffixName, hasCoOwner) {
    return tmxApiCall('put', '/vehicle', {
      applicationId,
      coOwnerFirstName,
      coOwnerMiddleName,
      coOwnerLastName,
      coOwnerSuffixName,
      hasCoOwner
    })
  },

  async getRegistrationCounties (state) {
    return tmxApiCall('get', '/registrationCounties', {
      params: {
        state
      }
    })
  },

  async suggestVehicleType (searchText) {
    return tmxApiCall('get', '/vehicleTypeDetails', {
      params: {
        searchText
      }
    })
  },

  async getVehicleDetailsByUVC (uvc) {
    return tmxApiCall('get', '/vehicleDetailsByUVC', {
      params: {
        uvc
      }
    })
  }
}
